import { Step } from "react-joyride";

const closeTruckingModal = () => {
  (document.querySelector(".tour-trucking-modal-close") as HTMLElement | null)?.click();
};

const closeProductPanel = () => {
  if (!document.querySelector(".tour-measure-job")) return;
  (document.querySelector(".tour-product-expand") as HTMLElement | null)?.click();
};

const materialTruckingSectionTourSteps: Step[] = [
  {
    target: ".tour-material-trucking",
    content: "Now you may fine-tune your materials and trucking.",
  },
  {
    target: ".tour-plant-dropdown",
    content: "This is the Plant that you will be buying material from.",
    placement: "right",
  },
  {
    target: ".tour-plant-material-dropdown",
    content: "Select the material(s) you will be using from this Plant.",
    placement: "right",
  },
  {
    target: ".tour-depth",
    content: "Your default depth for application of the chosen material.",
  },
  {
    target: ".tour-tons",
    content: "Tons needed based on the Job Size and Depth.",
  },
  {
    target: ".tour-material-cost",
    content: "The Cost of the selected Material from the chosen Plant.",
  },
  {
    target: ".tour-configure-trucking",
    content: "Click here to view and edit your Trucking Configuration.",
    buttons: [],
    overlayClickAction: false,
    dismissKeyAction: false,
  },
  {
    target: ".tour-transfer-truck-rt",
    content: "The round trip time from the job site to the selected plant.",
  },
  {
    target: ".tour-load-unload-buffer",
    content: "A time cushion for loading and Unloading that gets added to Round Trip time.",
  },
  {
    target: ".tour-truck-type",
    content: "This is the name of the truck you'll be using to haul material.",
  },
  {
    target: ".tour-truck-tons",
    content: "How much this truck can haul per trip.",
  },
  {
    target: ".tour-truck-rate",
    content: "The hourly rate for this truck.",
  },
  {
    target: ".tour-tons-per-hour",
    content: "Based on Job Time details or Production Rate. This is how many tons you need to move per hour.",
  },
  {
    target: ".tour-trucks-count",
    content:
      "Based on the Travel Time to and from the plant, this is how many trucks will be needed to maintain the Production Rate.",
  },
  {
    target: ".tour-hours-per-truck",
    content: "Based on the RT travel time, this shows how many hours each truck will need to run.",
  },
  {
    target: ".tour-hauling-hours",
    content:
      "Based on the Hours per Truck and the number of trucks needed, this shows the total hauling hours required.",
  },
  {
    target: ".tour-truck-cost",
    content: "Total Hauling Hours multiplied by the Rate gives you your total Trucking Cost.",
  },
  {
    target: ".tour-truck-row",
    content: "All numbers may be adjusted as needed.",
  },
  {
    target: ".tour-add-trucking-cost",
    content:
      "When you have finished determining your Trucking Cost, click here to add the Cost to the proposal.",
    after: closeTruckingModal,
  },
  {
    target: ".tour-material-cost-summary",
    content:
      "This is your cost for Trucking, Material, and the Total Cost to get material to and from the job.",
    after: closeProductPanel,
  },
];

export default materialTruckingSectionTourSteps;
